import BasicService from "./BasicService";

class AssignService extends BasicService {
  constructor() {
    super();
  }

  getAssignByItemId(itemId) {
    let url = `/orders/${itemId}/assigns`;
    return this.axios.get(url).then(response => response.data);
  }

  saveAssign(itemId, assign) {
    let url = `/orders/${itemId}/assigns`;
    return this.axios.post(url, assign).then(response => response.data);
  }

  updateAssign(itemId, assignId, assign) {
    let url = `/orders/${itemId}/assigns/${assignId}`;
    return this.axios.put(url, assign).then(response => response.data);
  }
}

const assignService = new AssignService();
export default assignService;
